import React, { useContext } from 'react';
import { CalloutCard } from '.';
import styles from './styles.scss';
import { TrackingContext } from '../../TrackingContext';

const CTA_IMAGE_SRC = 'https://media-api.xogrp.com/images/6a4ddad0-9250-41d0-a8ae-0dd9ce2c2d39';
const INVITATIONS_ROUTE = 'https://www.theknot.com/paper/invitations';

const DEFAULT_DESCRIPTION = 'Share the details with designs that match your wedding vibe.';
const SALE_DESCRIPTION = 'Save 30% + free shipping on designs that match your wedding website.';
const SALE_START = new Date('2026-07-06');
const SALE_END = new Date('2026-07-21T23:59:59');

export const PaperCallout: React.FC = () => {
  const { track } = useContext(TrackingContext);
  const now = new Date();
  const isSaleActive = now >= SALE_START && now <= SALE_END;
  const calloutDescription = isSaleActive ? SALE_DESCRIPTION : DEFAULT_DESCRIPTION;

  const handleClick = () => {
    track('WWS Preview Interaction', {
      action: 'clicked see invites & paper callout',
    });
  };

  return (
    <div className={styles.paperCallout}>
      <CalloutCard
        title="See invites & paper"
        description={calloutDescription}
        linkText="See invitations"
        linkTo={INVITATIONS_ROUTE}
        imageSrc={CTA_IMAGE_SRC}
        onClick={handleClick}
        data-testid="paper-callout"
      />
    </div>
  );
};
